import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Network } from "lucide-react";

export default function Login() {
  const { login, apiErr } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      nav(u.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md fade-up">
        <Link to="/" className="flex items-center gap-3 mb-10">
          <img src="/asiyanna-logo.jpg" alt="asiyanna" className="w-11 h-11 rounded-lg object-cover" />
          <span className="font-display font-bold text-xl lowercase">asiyanna</span>
        </Link>
        <div className="tag mb-4">Sign in</div>
        <h1 className="font-display font-black text-3xl sm:text-4xl mb-8">Welcome back to your network.</h1>
        <form onSubmit={submit} className="space-y-5">
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Email</Label>
            <Input
              data-testid="login-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-2 h-12 bg-card border-border focus:border-primary focus:ring-primary"
              placeholder="you@example.com"
            />
          </div>
          <div>
            <Label className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Password</Label>
            <Input
              data-testid="login-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-12 bg-card border-border focus:border-primary focus:ring-primary"
              placeholder="••••••••"
            />
          </div>
          <Button data-testid="login-submit-btn" type="submit" disabled={busy} className="w-full h-12 rounded-full bg-primary text-primary-foreground hover:bg-primary/90 glow-pill">
            {busy ? "Signing in..." : "Sign in"}
          </Button>
        </form>
        <div className="mt-6 text-sm text-muted-foreground">
          Need access? Contact your administrator.
        </div>
      </div>
    </div>
  );
}
